import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';
import NumeralService from '@/modules/core/app/services/NumeralService';
import { ColumnFormat } from '@/modules/core/app/constants/data.constants';

export class StripeTransferData extends BaseEntityModel {
  public destination: string;

  public amount: number | null;

  constructor(model: Partial<StripeTransferData> = {}) {
    super(model);

    this.destination = model.destination as string;
    this.amount = model.amount ?? null;
  }

  get formattedAmount(): string {
    return NumeralService.formatValue(this.amount! / 100, ColumnFormat.FORMAT_CURRENCY, 2);
  }
}
